var _defs, _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:red;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.5,
    cy: 62.5,
    r: 61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,4.5A59.5,59.5,0,1,1,4.5,64,59.57,59.57,0,0,1,64,4.5m0-3A62.5,62.5,0,1,0,126.5,64,62.5,62.5,0,0,0,64,1.5Z",
    transform: "translate(-1.5 -1.5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.5,
    cy: 62.5,
    r: 51
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,14.5A49.5,49.5,0,1,1,14.5,64,49.56,49.56,0,0,1,64,14.5m0-3A52.5,52.5,0,1,0,116.5,64,52.51,52.51,0,0,0,64,11.5Z",
    transform: "translate(-1.5 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.256538a984a6e164bda737e4348c33df.svg";
export { ForwardRef as ReactComponent };